import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { updateUriRef } from '../../../actions/filterActions';

// components
import { SbSharedRefineMenuLink } from '../../SbSharedRefineMenu/SbSharedRefineMenuLink/SbSharedRefineMenuLink';
import { SbSharedRefineMenuExpandableItemList } from '../../SbSharedRefineMenu/SbSharedRefineMenuExpandableItemList/SbSharedRefineMenuExpandableItemList';

export const SbRespRefineMenuLinkListComponent = props => {
    const { filterName, values, onClick, shouldIndent } = props;

    return (
        <SbSharedRefineMenuExpandableItemList
            filterName={filterName}
            availableFilterValues={values}
        >
            {({ valuesToShow }) =>
                valuesToShow.map(value => {
                    const { displayName, count, linkReference, linkable, isHidden } = value;
                    return (
                        <SbSharedRefineMenuLink
                            onClick={e => {
                                e.preventDefault();
                                onClick(filterName, value);
                            }}
                            count={count}
                            linkReference={linkReference}
                            linkable={linkable}
                            key={displayName}
                            text={displayName}
                            shouldIndent={shouldIndent}
                            isHidden={isHidden}
                        />
                    );
                })
            }
        </SbSharedRefineMenuExpandableItemList>
    );
};

SbRespRefineMenuLinkListComponent.defaultProps = {
    onClick: () => {},
};

SbRespRefineMenuLinkListComponent.propTypes = {
    onClick: PropTypes.func,
    shouldIndent: PropTypes.bool,
    values: PropTypes.array.isRequired,
    filterName: PropTypes.string.isRequired,
};

function mapDispatchToProps(dispatch) {
    return {
        onClick(filterName, filterValue) {
            dispatch(updateUriRef({ filterName, filterValue }));
        },
    };
}

export const SbRespRefineMenuLinkList = connect(
    null,
    mapDispatchToProps
)(SbRespRefineMenuLinkListComponent);
